export enum GenderId {
  NONE = '0',
  MASCULINO = '1',
}
